import { render } from "./NotificationsTool.vue?vue&type=template&id=25e05c5a"
import script from "./NotificationsTool.vue?vue&type=script&lang=js"
export * from "./NotificationsTool.vue?vue&type=script&lang=js"

import "./NotificationsTool.vue?vue&type=style&index=0&id=25e05c5a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__